import { c as e } from "react/compiler-runtime";
import { jsx as t } from "react/jsx-runtime";
import n from "@jetbrains/icons/search";
import r from "@jetbrains/ring-ui-built/components/input/input";
//#region src/components/SearchInput/SearchInput.tsx
var i = (i) => {
	let a = e(8), o, s, c;
	if (a[0] !== i) {
		let { onChange: e, className: t, ...n } = i;
		o = t, s = n, c = (t) => {
			e(t.target.value);
		}, a[0] = i, a[1] = o, a[2] = s, a[3] = c;
	} else o = a[1], s = a[2], c = a[3];
	let l = c, u;
	return a[4] !== o || a[5] !== l || a[6] !== s ? (u = /* @__PURE__ */ t(r, {
		icon: n,
		"aria-label": "search",
		placeholder: "Search",
		onChange: l,
		className: o,
		...s
	}), a[4] = o, a[5] = l, a[6] = s, a[7] = u) : u = a[7], u;
};
//#endregion
export { i as SearchInput };
